import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'

import ProductCard from '../ProductCard'

import './index.css'

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class PrimeDealsSection extends Component {
  state = {
    primeDeals: [],
    apiStatus: apiStatusConstants.initial,
    seconds: 172800,
  }

  componentDidMount() {
    this.getPrimeDeals()
    this.timerId = setInterval(this.tick, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.timerId)
  }

  tick = () => {
    this.setState(prevState => {
      if (prevState.seconds === 0) {
        clearInterval(this.timerId)
        return {seconds: 0}
      }
      return {seconds: prevState.seconds - 1}
    })
  }

  getPrimeDeals = async () => {
    this.setState({
      apiStatus: apiStatusConstants.inProgress,
    })

    const jwtToken = Cookies.get('jwt_token')

    const apiUrl = 'https://apis.ccbp.in/prime-deals'
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(apiUrl, options)
    if (response.ok === true) {
      const fetchedData = await response.json()
      const updatedData = fetchedData.prime_deals.map(product => ({
        title: product.title,
        brand: product.brand,
        price: product.price,
        id: product.id,
        imageUrl: product.image_url,
        rating: product.rating,
      }))
      this.setState({
        primeDeals: updatedData,
        apiStatus: apiStatusConstants.success,
      })
    }
    if (response.status === 401) {
      this.setState({
        apiStatus: apiStatusConstants.failure,
      })
    }
  }

  renderPrimeDealsListView = () => {
    const {primeDeals, seconds} = this.state

    const minutes = Math.floor((seconds % 3600) / 60)

    const secs = seconds % 60
    const formatedMinutes = minutes < 10 ? `0${minutes}` : minutes
    const formatedSeconds = secs < 10 ? `0${secs}` : secs
    const days = Math.floor(seconds / (24 * 60 * 60))

    const hours = Math.floor((seconds % (24 * 60 * 60)) / 3600)
    const formatedHours = hours < 10 ? `0${hours}` : hours

    return (
      <div>
        <div className="timer-card">
          <h1 className="timer-heading">Prime Deals expires in</h1>
          <h2 className="timer">
            {days}d: {formatedHours}h: {formatedMinutes}m: {formatedSeconds}s:
          </h2>
        </div>

        <h1 className="primedeals-list-heading">Exclusive Prime Deals</h1>

        <ul className="products-list">
          {primeDeals.map(product => (
            <ProductCard productData={product} key={product.id} />
          ))}
        </ul>
      </div>
    )
  }

  renderPrimeDealsFailureView = () => (
    <img
      src="https://assets.ccbp.in/frontend/react-js/exclusive-deals-banner-img.png"
      alt="register prime"
      className="register-prime-img"
    />
  )

  renderLoadingView = () => (
    <div className="primedeals-loader-container">
      <Loader type="ThreeDots" color="#0b69ff" height="50" width="50" />
    </div>
  )

  render() {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderPrimeDealsListView()
      case apiStatusConstants.failure:
        return this.renderPrimeDealsFailureView()
      case apiStatusConstants.inProgress:
        return this.renderLoadingView()
      default:
        return null
    }
  }
}

export default PrimeDealsSection
